import api from "../api/api";

export const optimizeRoute = async (distances) => {
    const response = await api.post("/RouteOptimization/optimize", {
        distances,
    });

    return response.data;
};